export const AUDIO_LS_KEY = 'innovaccer-audio-generating';
export const AUDIO_STARTED_EVENT = 'innovaccer:audio-generation-started';
